module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "navtype"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content clearfix"
  }, [_c('ul', {
    staticClass: "type-list"
  }, _vm._l((_vm.typeData), function(type) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(type))])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h2', [_vm._v("分类浏览")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0be5e79d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/navtype/navtype.vue
// module id = 54
// module chunks = 1